import { createFileRoute } from '@tanstack/react-router'
import * as v from 'valibot'

import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'
import { Glossary } from '@/glossary/components/Glossary/Glossary'

export const Route = createFileRoute('/_learning/glossary/{-$letter}')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-glossary',
        }),
      },
    ],
  }),
  component: RouteComponent,
  validateSearch: v.object({
    search: v.optional(v.string()),
  }),
})

function RouteComponent() {
  return <Glossary />
}
